$ = require 'jquery'
_ = require 'underscore'
Hearsay = require 'hearsay'
pluginsChangedSignal = require 'app/scripts/views/internal/plugins/plugins-changed-signal'
Promise = require 'bluebird'
View = require 'app/scripts/views/internal/view'

module.exports = class PluginView extends View
  constructor: ->
    @_retained = []
    @_pendingPromises = []
    @_eventListeners = []
    super

  _retainCallback: (callback) ->
    if callback? && @_retained?
      callback.retain().catch (err) ->
        # this can fail for a lot of legitamate reasons due to the async nature
        # of Power-Ups so just print a warning
        console?.warn(err.message)
      @_retained.push(callback)
    callback

  retain: (obj) ->
    if _.isFunction(obj)
      @_retainCallback(obj)
    else if _.isArray(obj)
      obj.forEach (item) =>
        @retain(item)
    else if _.isObject(obj)
      @retain _.values(obj)

    return

  cancelOnRemove: (promise) ->
    promise.cancellable()

    if @_pendingPromises?
      # You have to set the catch for CancellationError *before* adding this
      # promise to @_pendingPromises, or else when you cancel it in `remove`
      # the exception bubbles up to a parent promise (_promise0) and still
      # shows in the console and in our logs (I didn't figure out why that is,
      # looked like a bug in Bluebird).
      promise
        .then =>
          @_pendingPromises = _.without(@_pendingPromises, promise)
        .catch Promise.CancellationError, (->)
      @_pendingPromises.push(promise)
    else
      promise
        .catch Promise.CancellationError, (->)
        .cancel()
    promise

  remove: ->
    super

    for promise in @_pendingPromises
      promise.cancel()
    delete @_pendingPromises

    for { target, type, callback } in @_eventListeners
      target.removeEventListener type, callback
    delete @_eventListeners

    # Remove these last, since it's possible that a promise or a callback
    # will try to use them
    for retained in @_retained
      retained.release().catch (err) -> # noop, we don't care if this fails
    delete @_retained

    return

  addEventListener: (target, type, callback) ->
    target.addEventListener type, callback
    @_eventListeners.push({ target, type, callback })

  handleIFrameMessage: null

  initIFrames: (board, card, changedSignals...) ->
    $iframes = @$el.find('iframe.plugin-iframe')

    combinedSignal = Hearsay.combine changedSignals.concat(pluginsChangedSignal(board, card))...

    _.each $iframes, (iframe) =>
      unuseCombinedSignal = combinedSignal.use()

      $iframe = $(iframe)
      $iframe
      .addClass('iframe-loading')
      .one 'load', (e) =>
        $iframe.removeClass('iframe-loading')

        @subscribe combinedSignal, =>
          iframe.contentWindow?.postMessage('render', '*')
        unuseCombinedSignal()

        if @handleIFrameMessage?
          @addEventListener window, 'message', (e) =>
            if e.source == iframe.contentWindow
              @handleIFrameMessage(iframe, e.data)
            return
        return
      return
    return
